import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { IoClose } from 'react-icons/io5';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { GetVendorImages } from 'API/VendorOnboarding/api';
import { useState } from 'react';
import SnackBar from '../General/SnackBar';
import BackdropLoader from '../General/Loader';
import ImageModal from './ImageModal';

export default function DocumentsModel(props) {
  console.log('props', props);

  const [image, setImage] = React.useState(null);
  const [OpenImage, setImageOpen] = useState(false);
  const [filetype, setFiletype] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [SelectedNumber, setSelectedNumber] = React.useState();

  const [error, setError] = React.useState(null);
  const [openAlert, setOpenAlert] = React.useState(false);
  const [AlertType, setAlertType] = React.useState('');

  const handleAlertOpen = (type, message) => {
    setAlertType(type);
    setError(message);
    setOpenAlert(true);
  };

  const handleImageOpen = () => {
    setImageOpen(true);
  };

  const handleClose = () => {
    setImageOpen(false);
  };

  const handleAlertClose = () => {
    setOpenAlert(false);
  };

  const getImage = (url, index) => {
    GetVendorImages(url, setImage, handleImageOpen, handleAlertOpen, setFiletype, setIsLoading);
    setSelectedNumber(index);
  };

  return (
    <React.Fragment>
      <BackdropLoader open={isLoading} />
      <ImageModal open={OpenImage} handleClose={handleClose} isLoading={isLoading} image={image} fileType={filetype} />
      <SnackBar open={openAlert} message={error} type={AlertType} handleClose={handleAlertClose} />

      <Dialog open={props.open} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" maxWidth="sm" fullWidth>
        <Box sx={{ position: 'absolute', top: 10, right: 10, cursor: 'pointer', fontSize: '25px' }} onClick={props.handleClose}>
          <IoClose />
        </Box>
        <DialogTitle id="alert-dialog-title">
          <Typography variant="h5">Documents</Typography>
        </DialogTitle>
        <DialogContent>
          <table>
            <tr>
              <th style={{ textAlign: 'left' }}>Pan Card</th>
              <td></td>
              <td>
                <Button
                  variant="contained"
                  disabled={isLoading && SelectedNumber === 1}
                  size="small"
                  sx={{
              backgroundColor: '#592375',
              color: '#FFFFFF',
              borderRadius: '6px',
              '&:hover': {
                backgroundColor: '#592375'
              }
            }}
                  color="secondary"
                  onClick={() => getImage(props.data.pan_card, 1)}
                >
                  {isLoading && SelectedNumber === 1 ? <CircularProgress size="22px" color="grey" /> : 'View'}
                </Button>
              </td>
            </tr>
            <tr>
              <th style={{ textAlign: 'left' }}>GST No.</th>
              <td></td>
              <td>
                <Button
                  variant="contained"
                  disabled={isLoading && SelectedNumber === 2}
                  size="small"
                  sx={{
              backgroundColor: '#592375',
              color: '#FFFFFF',
              borderRadius: '6px',
              '&:hover': {
                backgroundColor: '#592375'
              }
            }}
                  color="secondary"
                  onClick={() => getImage(props.data.gst_no, 2)}
                >
                  {isLoading && SelectedNumber === 2 ? <CircularProgress size="22px" color="grey" /> : 'View'}
                </Button>
              </td>
            </tr>
            <tr>
              <th style={{ textAlign: 'left' }}>Copy of Passbook/Cancelled cheque</th>
              <td></td>
              <td>
                <Button
                  variant="contained"
                  disabled={isLoading && SelectedNumber === 3}
                  size="small"
                  sx={{
              backgroundColor: '#592375',
              color: '#FFFFFF',
              borderRadius: '6px',
              '&:hover': {
                backgroundColor: '#592375'
              }
            }}
                  color="secondary"
                  onClick={() => getImage(props.data['passbook/cancelled_cheque'], 3)}
                >
                  {isLoading && SelectedNumber === 3 ? <CircularProgress size="22px" color="grey" /> : 'View'}
                </Button>
              </td>
            </tr>
          </table>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
